<template>
	<div v-if="hasDraftStarted" class="draft-status">
		<span class="now-picking-value">{{ current_picker.name }}</span>
		<span class="now-picking-label">Picker</span>
		<span class="mt-3 uppercase">Rd: {{ current_round }}</span>
	</div>
</template>

<style lang="scss" scoped>
.draft-status {
	@apply flex flex-col items-center justify-center text-center px-5 border-gray-500 border-r sm:w-56;
}

.now-picking-label {
	@apply uppercase text-xs;
}

.now-picking-value {
	@apply text-base border-b-2;
}
</style>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters(['hasDraftStarted']),
		...mapState(['current_picker', 'current_round']),
	},
};
</script>
